module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 11.144 11.144\"><path id=\"パス_6\" data-name=\"パス 6\" d=\"M2808.1,4416.694a5.549,5.549,0,0,1,3.838,1.543l.8-.8a.539.539,0,0,1,.92.382v3.012a.539.539,0,0,1-.539.539h-3.012a.54.54,0,0,1-.381-.921l.938-.938a3.774,3.774,0,1,0-.092,5.6.27.27,0,0,1,.368.012l.891.891a.271.271,0,0,1-.011.392,5.572,5.572,0,1,1-3.723-9.708Z\" transform=\"translate(-2802.52 -4416.694)\" fill=\"#fff\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/plugin/redo.svg
// module id = yYKm
// module chunks = 1